import { InputAdornment, TextField } from "@material-ui/core";
import { useRuleValidator } from "hooks/useRuleValidator";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUnitCil } from "redux/actions/inventories/inventoriesAction";
import { PERMISSIONS } from "router/permissions";

export const UpdateCilComponent = ({ data, cil = "cil10" }) => {
  const dispatch = useDispatch();
  const { inventory } = useSelector(({ inventories }) => inventories);
  const status = inventory?.status;
  const haRule = useRuleValidator(PERMISSIONS.INVENTORIES_CONTROL_EDIT)

  const handleInventoryCil = ({ target }, _v) => {
    const parsing = parseInt(target?.value || "");
    let value = parsing < 0 ? 0 : parsing;

    if (isNaN(value)) value = 0;
    dispatch(
      updateUnitCil(
        data.idUnit,
        target.name,
        parseFloat(value < 0 ? 0 : value)
      )
    );
  };

  return (
    <>
      {status === "CLOSED" ? (
        <>{data[cil]} cil</>
      ) : (
        <TextField
          value={data[cil] === 0 ? "" : data[cil]}
          name={cil}
          onChange={(e) => handleInventoryCil(e)}
          inputProps={{ min: 0, textAlign: "right" }}
          InputProps={{
            endAdornment: <InputAdornment position="end">cil</InputAdornment>,
          }}
          disabled={!haRule}
          // onFocus={(e) => handleInventoryCil(e, true)}
        />
      )}
    </>
  );
};
